import React from 'react';
import { sortBy } from 'lodash';

export default function useSortedAndFilteredAccounts(
  accounts,
  hideAccountsWithoutHoldings,
) {
  const sortedAccounts = React.useMemo(() => {
    if (!accounts) return null;

    const accountTree = {};
    const options = accounts
      .meta()
      .field('accountType')
      .options();
    for (const opt of options) { // eslint-disable-line
      accountTree[opt.id()] = {
        id: opt.id(),
        label: opt.attr('prompt'),
        accounts: [],
      };
    }
    for (const acc of accounts) {      // eslint-disable-line
      if (hideAccountsWithoutHoldings && acc.attr('holdings')?.resources().list().length === 0) continue; // eslint-disable-line

      accountTree[acc.attr('accountType')].accounts.push(acc);
    }

    return sortBy(Object.values(accountTree), a => a.accounts.label);
  }, [accounts, hideAccountsWithoutHoldings]);

  return sortedAccounts;
}
